// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {
  id?: string,
  checked?: boolean,
  onChange?: (SyntheticInputEvent<HTMLInputElement>) => void,
  dataTestId?: string,
};

export function CheckboxField({ id, checked, onChange, dataTestId }: Props): Node {
  return (
    <Label data-test-id={dataTestId} htmlFor={id}>
      <div>
        <Input id={id} type="checkbox" checked={checked} onChange={onChange} />
        <Checkmark />
      </div>
    </Label>
  );
}

const Checkmark = styled.span`
  height: 1.2em;
  width: 1.2em;
  margin-right: 0.6em;
  display: block;

  border-radius: 2px;
  border: 1px solid ${props => props.theme.colors.new_primary[800]};
  background-color: transparent;

  position: relative;
  :after {
    content: '';
    position: absolute;
    display: none;

    bottom: 0;
    left: 0;
    right: 0;
    top: 0;

    background-color: transparent;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAA7EAAAOxAGVKw4bAAABNklEQVRIx+3SIUgEQRTG8WM5jgsXLhjFIAaD4RCD4YJBxGAwGAwGg8FgMBkMNqPRZDSZROQwGExGo8EgBjGIiCyG5Xbe+69lB5ZzZ27PXdt98NrM75thplYbJxNgCeipaus/8C7wDSTAXaUlwCIQpnhSaQmwAHwN4HZuyuId4NOBR8ByGXwO+HDgfWD11yZVnTfGNIbhqjoLvHvwtbwTraTXuhKRpgefAd4cuAHWfbhdeCsirRx8Gnj14Bt5JxrE7dyrajuzbgp4ceAKbLoe69qxKQEeVHVCVSeBZw++5XwwEWkCPU/JI/DkwbeHfrm05NJT4pqdwv9aRBrAxQj4bmE8U1IHzgvgeyPjNsaYOnDmwff/jNvEcRwApzn4QWncJoqiADjJ4IeV4TZhGAbAMXBUOT6OzQ+8k9qof8W2WgAAAABJRU5ErkJggg==');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70%;
  }
`;

const Input = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  height: 0;
  width: 0;
  position: absolute;

  :checked ~ ${Checkmark} {
    :after {
      display: block;
    }
    background-color: ${props => props.theme.colors.new_primary[500]};
    border: 1px solid ${props => props.theme.colors.new_primary[500]};
  }
`;

const Label = styled.label`
  display: flex;
  cursor: pointer;
  user-select: none;
  > * {
    align-self: center;
  }
`;
